module.exports = __webpack_public_path__ + "static/media/document-icon.3a315812.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/document-icon.svg
// module id = 387
// module chunks = 0